import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../store';

export const SHARED_SESSION_GRANT_ID_KEY = 'shared_session_grant_id';
export const SHARED_SESSION_RESOURCE_TYPE_KEY = 'shared_session_resource_type';

export type SharedSessionState = Readonly<{
  active: boolean;
  token: string | null;
  ownerFirstName: string;
  ownerLastName: string;
  ownerProfileImageUrl: string | null;
}>;

const initialState: SharedSessionState = {
  active: false,
  token: null,
  ownerFirstName: '',
  ownerLastName: '',
  ownerProfileImageUrl: null,
};

export const sharedAccountSessionSlice = createSlice({
  name: 'sharedAccountSession',
  initialState,
  reducers: {
    activateSharedAccountSession: (
      state,
      action: PayloadAction<{
        token: string;
        ownerFirstName: string;
        ownerLastName: string;
        ownerProfileImageUrl: string | null;
      }>,
    ) => {
      state.active = true;
      state.token = action.payload.token;
      state.ownerFirstName = action.payload.ownerFirstName;
      state.ownerLastName = action.payload.ownerLastName;
      state.ownerProfileImageUrl = action.payload.ownerProfileImageUrl;
    },

    deactivateSharedAccountSession: () => {
      // clear grant ID and resource type from localStorage when deactivating & reset the slice
      localStorage.removeItem(SHARED_SESSION_GRANT_ID_KEY);
      localStorage.removeItem(SHARED_SESSION_RESOURCE_TYPE_KEY);

      return initialState;
    },
  },
});

export const { activateSharedAccountSession, deactivateSharedAccountSession } =
  sharedAccountSessionSlice.actions;

// Selectors
export const selectSharedAccountSession = (state: RootState) => state.sharedAccountSession;
export const selectIsSharedAccountSessionActive = (state: RootState) =>
  state.sharedAccountSession.active;
export const selectSharedAccountSessionToken = (state: RootState) =>
  state.sharedAccountSession.token;
export const selectSharedAccountSessionOwnerFirstName = (state: RootState) =>
  state.sharedAccountSession.ownerFirstName;
export const selectSharedAccountSessionOwnerLastName = (state: RootState) =>
  state.sharedAccountSession.ownerLastName;
export const selectSharedAccountSessionOwnerProfileImageUrl = (state: RootState) =>
  state.sharedAccountSession.ownerProfileImageUrl;
